import PermissionsPanel from '../components/chat/PermissionsPanel'

export default function Permissions() {
  return (
    <div className="flex flex-1 flex-col">
      <header className="border-b border-stone-200 px-4 py-4 sm:px-6">
        <h1 className="text-base font-medium text-stone-900">Permissions</h1>
        <p className="mt-0.5 text-sm text-stone-500">
          Actions you've approved for this brand with "Always allow". Revoking makes the assistant ask
          again next time.
        </p>
      </header>

      <section className="px-1 py-2 sm:px-3">
        <PermissionsPanel heading={false} />
      </section>
    </div>
  )
}
